import { tv } from "tailwind-variants";
import { Size } from "../helpers/helpers.js";

export const toggleButtonGroupStyle = tv({
  slots: {
    group:
      "inline-flex max-w-max rounded-md bg-gray-100 p-0.5 ring-1 ring-border-strong ring-inset",
    button:
      "flex cursor-pointer items-center justify-center rounded-[5px] text-muted-foreground transition-colors hover:text-gray-700 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-indigo-600 focus-visible:ring-inset disabled:cursor-not-allowed disabled:opacity-50 selected:bg-white selected:text-foreground selected:shadow-xs selected:ring-1 selected:ring-border-strong selected:ring-inset",
  },
  variants: {
    size: {
      [Size.SMALL]: {
        group: "h-7",
      },
      [Size.MEDIUM]: {
        group: "h-8",
      },
    },
    // Icon-only segments are square; labeled segments size to their text.
    hasLabel: {
      true: {
        button: "gap-1.5 px-2.5 font-medium",
      },
    },
  },
  compoundVariants: [
    { size: Size.SMALL, hasLabel: false, class: { button: "size-6" } },
    { size: Size.MEDIUM, hasLabel: false, class: { button: "size-7" } },
    { size: Size.SMALL, hasLabel: true, class: { button: "text-xs" } },
    { size: Size.MEDIUM, hasLabel: true, class: { button: "text-sm" } },
  ],
  defaultVariants: {
    size: Size.MEDIUM,
    hasLabel: false,
  },
});

/**
 * A chip-style multi-select toggle group: a wrapping row of bordered pills, each
 * independently selectable. Distinct from {@link toggleButtonGroupStyle}, which
 * is a compact segmented control (a single background pill of icon buttons). Use
 * this when each option carries a short text label — e.g. a weekday picker.
 *
 * Colors come from semantic tokens: `primary` resolves to indigo-600, so the
 * selected state matches the design mock's indigo chips without hard-coding a
 * palette color.
 */
export const toggleChipGroupStyle = tv({
  slots: {
    group: "flex flex-wrap gap-2",
    button:
      "cursor-pointer rounded-md border border-border-light bg-white px-3 py-1.5 text-sm text-muted-foreground transition-colors outline-none hover:border-border-strong hover:text-foreground focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50 selected:border-primary selected:bg-primary/10 selected:font-medium selected:text-primary",
  },
});
